/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const DepartmentBarChart = ({ data }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  const chartData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: 'Departmental Notices',
        data: data.map((item) => item.value),
        backgroundColor: ['#fefa21ff','#2f78c4','#099b09ff'],
        borderRadius: 4,
        barPercentage:0.5,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: 'center',
        align: 'center',      
        color: 'black',          
        font: {
          size: 12,
          weight: 'bold',
        },
        formatter: (value) => value,
      },
    },
    responsive: true,
    scales: {
      y: {
        type: 'linear',
        position: 'bottom',
        beginAtZero: true,
        ticks: { precision: 0 ,
            stepSize: 10,
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', maxWidth: '100%', height: '210px' }}>
        <Bar data={chartData} options={options}/>
    </div>
  );
};

export default DepartmentBarChart;
